import { IconButton, styled } from '@mui/material';
import { ExpandMoreProps } from '../../types/interfaces/CampaingTypes';
import '../../CampaignManagement.scss';

export const ExpandMoreComponent = styled((props: ExpandMoreProps) => {
    return <IconButton {...props} />;
})(({ theme, expand }) => ({
    transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));
